import React, { HTMLProps } from "react";
import cn from "classnames";
import s from "../FilterPage.module.scss";

const Aside = ({ className, ...props }: HTMLProps<HTMLDivElement>) => (
  <div {...props} className={cn(className, s.input)} />
);

export default Aside;
